import React from 'react';
import PropTypes from 'prop-types';

const PaymentMessage = (props) => {
  if (props.state.payment.paymentOption === 'instalments') {
    return (
      <p>You have chosen to pay in instalments. You will be emailed an invoice that has our BACS details on it for direct/online bank transfer. It is recommended to set up a standing order to ensure smooth progression of your course. We will be in touch once payment has been cleared and when we have set up the course for you.</p>
    )
  } else {
    return (
      <p>You are making a one-off payment for £{props.state.course.price}. You will redirected to our payment provider Stripe to complete your purchase.</p>
    )
  }
}

const PaymentDetails = ({ checkoutState, onSubmit }) => {
  return (
    <form action='' className='checkout__form checkout__form--payment-details'>
      <h2>Payment details</h2>
      <PaymentMessage state={checkoutState} />
      <button role="link" onClick={onSubmit} className='button button--l' style={{marginTop: '30px', marginLeft: '180px', marginRight: 'auto'}}>
        Checkout
      </button>
    </form>
  );
}

PaymentDetails.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  checkoutState: PropTypes.object.isRequired
};

export default PaymentDetails;



// WEBPACK FOOTER //
// ./src/views/Checkout/PaymentDetails/index.js